// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Profile Management - Modern Design
 */

.profile-management {
  padding: var(--space-8);
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);
}

/* Profile Header */
.profile-header {
  margin-bottom: var(--space-8);
}

.profile-header__content {
  display: flex;
  align-items: center;
  gap: var(--space-6);
  background: white;
  padding: var(--space-8);
  border-radius: var(--radius-3xl);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--neutral-200);
}

.profile-avatar {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--primary-500), var(--secondary-500));
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-md);
  flex-shrink: 0;
}

.profile-avatar__text {
  font-size: var(--text-2xl);
  font-weight: var(--font-weight-bold);
  color: white;
}

.profile-info {
  flex: 1 1;
}

.profile-name {
  font-size: var(--text-3xl);
  font-weight: var(--font-weight-bold);
  color: var(--neutral-900);
  margin: 0 0 var(--space-2) 0;
  background: linear-gradient(135deg, var(--primary-600), var(--secondary-600));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.profile-role {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--primary-600);
  margin: 0 0 var(--space-1) 0;
  background: var(--primary-50);
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-lg);
  display: inline-block;
}

.profile-email {
  font-size: var(--text-base);
  color: var(--neutral-600);
  margin: 0;
}

/* Profile Tabs */
.profile-tabs {
  display: flex;
  background: white;
  border-radius: var(--radius-2xl);
  padding: var(--space-2);
  margin-bottom: var(--space-8);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--neutral-200);
  overflow-x: auto;
}

.profile-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-6);
  border: none;
  background: none;
  border-radius: var(--radius-xl);
  cursor: pointer;
  transition: all var(--transition-base);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-600);
  min-width: 200px;
}

.profile-tab:hover {
  background: var(--neutral-50);
  color: var(--primary-600);
}

.profile-tab--active {
  background: linear-gradient(135deg, var(--primary-500), var(--secondary-500));
  color: white;
  box-shadow: var(--shadow-md);
}

.profile-tab__icon {
  font-size: var(--text-lg);
}

.profile-tab__label {
  font-size: var(--text-sm);
}

/* Profile Content */
.profile-content {
  animation: fadeInUp 0.4s ease-out;
}

/* Profile Card */
.profile-card__header {
  margin-bottom: var(--space-8);
  text-align: center;
}

.profile-card__title {
  font-size: var(--text-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--neutral-900);
  margin: 0 0 var(--space-3) 0;
}

.profile-card__subtitle {
  font-size: var(--text-base);
  color: var(--neutral-600);
  margin: 0;
  line-height: var(--line-height-relaxed);
}

.profile-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: var(--space-8);
  padding-top: var(--space-6);
  border-top: 1px solid var(--neutral-200);
}

/* Preferences */
.preferences-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.preference-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-6);
  background: var(--neutral-50);
  border-radius: var(--radius-xl);
  border: 1px solid var(--neutral-200);
  transition: all var(--transition-base);
}

.preference-item:hover {
  background: var(--neutral-100);
  border-color: var(--primary-200);
}

.preference-info {
  flex: 1 1;
}

.preference-title {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-900);
  margin: 0 0 var(--space-2) 0;
}

.preference-description {
  font-size: var(--text-sm);
  color: var(--neutral-600);
  margin: 0;
  line-height: var(--line-height-relaxed);
}

.preference-control {
  flex-shrink: 0;
}

/* Toggle Switch */
.preference-toggle {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 32px;
  cursor: pointer;
}

.preference-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.preference-toggle__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--neutral-300);
  transition: var(--transition-base);
  border-radius: var(--radius-full);
}

.preference-toggle__slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: var(--transition-base);
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-sm);
}

.preference-toggle input:checked + .preference-toggle__slider {
  background-color: var(--primary-500);
}

.preference-toggle input:checked + .preference-toggle__slider:before {
  transform: translateX(28px);
}

.preference-toggle:hover .preference-toggle__slider {
  box-shadow: var(--shadow-md);
}

/* Loading State */
.profile-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-management {
    padding: var(--space-4);
  }
  
  .profile-header__content {
    flex-direction: column;
    text-align: center;
    gap: var(--space-4);
    padding: var(--space-6);
  }
  
  .profile-avatar {
    width: 60px;
    height: 60px;
  }
  
  .profile-avatar__text {
    font-size: var(--text-xl);
  }
  
  .profile-name {
    font-size: var(--text-2xl);
  }
  
  .profile-tabs {
    flex-direction: column;
    gap: var(--space-2);
  }
  
  .profile-tab {
    min-width: auto;
    justify-content: flex-start;
  }
  
  .preference-item {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-4);
  }
  
  .preference-control {
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .profile-management {
    padding: var(--space-2);
  }
  
  .profile-header__content {
    padding: var(--space-4);
  }
  
  .profile-avatar {
    width: 50px;
    height: 50px;
  }
  
  .profile-avatar__text {
    font-size: var(--text-lg);
  }
  
  .profile-name {
    font-size: var(--text-xl);
  }
  
  .profile-tab {
    padding: var(--space-3) var(--space-4);
  }
  
  .profile-tab__label {
    font-size: var(--text-xs);
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Focus States */
.profile-tab:focus {
  outline: 2px solid var(--primary-500);
  outline-offset: 2px;
}

.preference-toggle:focus-within .preference-toggle__slider {
  outline: 2px solid var(--primary-500);
  outline-offset: 2px;
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .profile-management {
    background: linear-gradient(135deg, var(--neutral-800) 0%, var(--primary-900) 100%);
  }
  
  .profile-header__content {
    background: var(--neutral-800);
    border-color: var(--neutral-700);
  }
  
  .profile-name {
    color: var(--neutral-100);
  }
  
  .profile-email {
    color: var(--neutral-400);
  }
  
  .profile-tabs {
    background: var(--neutral-800);
    border-color: var(--neutral-700);
  }
  
  .profile-tab {
    color: var(--neutral-300);
  }
  
  .profile-tab:hover {
    background: var(--neutral-700);
    color: var(--primary-400);
  }
  
  .preference-item {
    background: var(--neutral-700);
    border-color: var(--neutral-600);
  }
  
  .preference-item:hover {
    background: var(--neutral-600);
    border-color: var(--primary-600);
  }
  
  .preference-title {
    color: var(--neutral-100);
  }
  
  .preference-description {
    color: var(--neutral-400);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/ProfileManagement.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6EAA6E;EAC7E,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,6EAA6E;EAC7E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,mFAAmF;EACrF;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/**\n * Profile Management - Modern Design\n */\n\n.profile-management {\n  padding: var(--space-8);\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);\n}\n\n/* Profile Header */\n.profile-header {\n  margin-bottom: var(--space-8);\n}\n\n.profile-header__content {\n  display: flex;\n  align-items: center;\n  gap: var(--space-6);\n  background: white;\n  padding: var(--space-8);\n  border-radius: var(--radius-3xl);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--neutral-200);\n}\n\n.profile-avatar {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, var(--primary-500), var(--secondary-500));\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-md);\n  flex-shrink: 0;\n}\n\n.profile-avatar__text {\n  font-size: var(--text-2xl);\n  font-weight: var(--font-weight-bold);\n  color: white;\n}\n\n.profile-info {\n  flex: 1;\n}\n\n.profile-name {\n  font-size: var(--text-3xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--neutral-900);\n  margin: 0 0 var(--space-2) 0;\n  background: linear-gradient(135deg, var(--primary-600), var(--secondary-600));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.profile-role {\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--primary-600);\n  margin: 0 0 var(--space-1) 0;\n  background: var(--primary-50);\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-lg);\n  display: inline-block;\n}\n\n.profile-email {\n  font-size: var(--text-base);\n  color: var(--neutral-600);\n  margin: 0;\n}\n\n/* Profile Tabs */\n.profile-tabs {\n  display: flex;\n  background: white;\n  border-radius: var(--radius-2xl);\n  padding: var(--space-2);\n  margin-bottom: var(--space-8);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--neutral-200);\n  overflow-x: auto;\n}\n\n.profile-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3);\n  padding: var(--space-4) var(--space-6);\n  border: none;\n  background: none;\n  border-radius: var(--radius-xl);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-600);\n  min-width: 200px;\n}\n\n.profile-tab:hover {\n  background: var(--neutral-50);\n  color: var(--primary-600);\n}\n\n.profile-tab--active {\n  background: linear-gradient(135deg, var(--primary-500), var(--secondary-500));\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.profile-tab__icon {\n  font-size: var(--text-lg);\n}\n\n.profile-tab__label {\n  font-size: var(--text-sm);\n}\n\n/* Profile Content */\n.profile-content {\n  animation: fadeInUp 0.4s ease-out;\n}\n\n/* Profile Card */\n.profile-card__header {\n  margin-bottom: var(--space-8);\n  text-align: center;\n}\n\n.profile-card__title {\n  font-size: var(--text-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--neutral-900);\n  margin: 0 0 var(--space-3) 0;\n}\n\n.profile-card__subtitle {\n  font-size: var(--text-base);\n  color: var(--neutral-600);\n  margin: 0;\n  line-height: var(--line-height-relaxed);\n}\n\n.profile-card__actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: var(--space-8);\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--neutral-200);\n}\n\n/* Preferences */\n.preferences-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.preference-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-6);\n  background: var(--neutral-50);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--neutral-200);\n  transition: all var(--transition-base);\n}\n\n.preference-item:hover {\n  background: var(--neutral-100);\n  border-color: var(--primary-200);\n}\n\n.preference-info {\n  flex: 1;\n}\n\n.preference-title {\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-900);\n  margin: 0 0 var(--space-2) 0;\n}\n\n.preference-description {\n  font-size: var(--text-sm);\n  color: var(--neutral-600);\n  margin: 0;\n  line-height: var(--line-height-relaxed);\n}\n\n.preference-control {\n  flex-shrink: 0;\n}\n\n/* Toggle Switch */\n.preference-toggle {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 32px;\n  cursor: pointer;\n}\n\n.preference-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.preference-toggle__slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--neutral-300);\n  transition: var(--transition-base);\n  border-radius: var(--radius-full);\n}\n\n.preference-toggle__slider:before {\n  position: absolute;\n  content: \"\";\n  height: 24px;\n  width: 24px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: var(--transition-base);\n  border-radius: var(--radius-full);\n  box-shadow: var(--shadow-sm);\n}\n\n.preference-toggle input:checked + .preference-toggle__slider {\n  background-color: var(--primary-500);\n}\n\n.preference-toggle input:checked + .preference-toggle__slider:before {\n  transform: translateX(28px);\n}\n\n.preference-toggle:hover .preference-toggle__slider {\n  box-shadow: var(--shadow-md);\n}\n\n/* Loading State */\n.profile-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profile-management {\n    padding: var(--space-4);\n  }\n  \n  .profile-header__content {\n    flex-direction: column;\n    text-align: center;\n    gap: var(--space-4);\n    padding: var(--space-6);\n  }\n  \n  .profile-avatar {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .profile-avatar__text {\n    font-size: var(--text-xl);\n  }\n  \n  .profile-name {\n    font-size: var(--text-2xl);\n  }\n  \n  .profile-tabs {\n    flex-direction: column;\n    gap: var(--space-2);\n  }\n  \n  .profile-tab {\n    min-width: auto;\n    justify-content: flex-start;\n  }\n  \n  .preference-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-4);\n  }\n  \n  .preference-control {\n    align-self: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .profile-management {\n    padding: var(--space-2);\n  }\n  \n  .profile-header__content {\n    padding: var(--space-4);\n  }\n  \n  .profile-avatar {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .profile-avatar__text {\n    font-size: var(--text-lg);\n  }\n  \n  .profile-name {\n    font-size: var(--text-xl);\n  }\n  \n  .profile-tab {\n    padding: var(--space-3) var(--space-4);\n  }\n  \n  .profile-tab__label {\n    font-size: var(--text-xs);\n  }\n}\n\n/* Animation */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Focus States */\n.profile-tab:focus {\n  outline: 2px solid var(--primary-500);\n  outline-offset: 2px;\n}\n\n.preference-toggle:focus-within .preference-toggle__slider {\n  outline: 2px solid var(--primary-500);\n  outline-offset: 2px;\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .profile-management {\n    background: linear-gradient(135deg, var(--neutral-800) 0%, var(--primary-900) 100%);\n  }\n  \n  .profile-header__content {\n    background: var(--neutral-800);\n    border-color: var(--neutral-700);\n  }\n  \n  .profile-name {\n    color: var(--neutral-100);\n  }\n  \n  .profile-email {\n    color: var(--neutral-400);\n  }\n  \n  .profile-tabs {\n    background: var(--neutral-800);\n    border-color: var(--neutral-700);\n  }\n  \n  .profile-tab {\n    color: var(--neutral-300);\n  }\n  \n  .profile-tab:hover {\n    background: var(--neutral-700);\n    color: var(--primary-400);\n  }\n  \n  .preference-item {\n    background: var(--neutral-700);\n    border-color: var(--neutral-600);\n  }\n  \n  .preference-item:hover {\n    background: var(--neutral-600);\n    border-color: var(--primary-600);\n  }\n  \n  .preference-title {\n    color: var(--neutral-100);\n  }\n  \n  .preference-description {\n    color: var(--neutral-400);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
